import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { MailboxesPage } from "@/features/outreach/MailboxesPage";

const search = z.object({
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/outreach/mailboxes")({
  validateSearch: search,
  component: () => <MailboxesPage search={Route.useSearch()} />,
});
